import { Component, OnInit, Input, Renderer2, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import * as chartingLibrary from '@toro/charting-library/charting_library/charting_library';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { SettingsService } from '@toro/common/shared/services/settings/settings.service';

@Component({
  selector: 'chart-wrapper-tradingview',
  templateUrl: './tradingview-wrapper.component.html',
  styleUrls: ['./tradingview-wrapper.component.scss']
})

export class ChartWrapperComponent implements OnInit {

    @Input() public symbol: string;
    @Input() public isFullScreen = true;

    public chart: any;

    public constructor(
      private store: Store<AppState>,
      private activatedRoute: ActivatedRoute,
      private settingsService: SettingsService,
      private renderer: Renderer2
    ) {}

    public ngOnInit() {
      this.checkForUrlSymbolAndInitialize();
      this.initOnReady();
    }

  public checkForUrlSymbolAndInitialize() {
    if (this.symbol) {
      this.symbol = this.validateFuture(this.symbol.toUpperCase());
      return;
    }

    this.activatedRoute.params.subscribe(params => {
      if (params.id && params.id.length > 2) {
        this.symbol = params.id.toUpperCase();

        if (this.isCrypto(this.symbol)) {
          this.symbol = this.normalizeCrypto(this.symbol);
          return;
        }

        if (this.isFuture(this.symbol)) {
          this.symbol = this.validateFuture(this.symbol);
        }
      } else {
        this.symbol = 'PETR4';
      }
    });
  }

    public isCrypto(symbol: string) {
        const crypto = this.settingsService.getConfigurationKeyValue('crypto').tickers;
        return crypto.includes(symbol);
    }

    public normalizeCrypto(symbol) {
        switch (symbol) {
            case "BTC": return "BITCOIN";
            case "ETH": return "ETHEREUM";
            default: return symbol;
        }
    }

    public isFuture(symbol: string) {
      const regexFirstThreeLetters = new RegExp(/^[A-Za-z]{3}/);
      const regexFirstThreeLettersMatch = regexFirstThreeLetters.exec(symbol);

      if (regexFirstThreeLettersMatch) {
        const symbolFirstThreeLetters = regexFirstThreeLettersMatch[0];
        const future = this.settingsService.getConfigurationKeyValue('future').tickers;
        return future.some(ticker => ticker === symbolFirstThreeLetters);
      }

      return false;
    }

    public validateFuture(symbol: string) {
        const regexSymbolEndsWithTwoDigits = new RegExp(/(?<!\d)\d{2}$/);
        const regexSymbolEndsWithTwoDigitsMatch = regexSymbolEndsWithTwoDigits.exec(symbol);

        if(regexSymbolEndsWithTwoDigitsMatch){
          const fullYear = new Date().getFullYear();
          const shortYear = Number(fullYear.toString().substr(2, 2));
          const symbolShortYear = Number(regexSymbolEndsWithTwoDigitsMatch[0]);

          if(symbolShortYear >= shortYear && symbolShortYear <= (shortYear + 1)){
            const symbolFullYear = symbolShortYear > shortYear ? fullYear + 1 : fullYear;
            symbol = symbol.replace(regexSymbolEndsWithTwoDigits, symbolFullYear.toString());
          }
        }

        return symbol;
    }

    public chartOverrides(): chartingLibrary.Overrides {
        // Estilo de gráfico padrão, pra não segurar o gráfico de linha quando visitar crypto
        const override: chartingLibrary.Overrides = {"mainSeriesProperties.style": chartingLibrary.SeriesStyle.Candles}
        if(this.isCrypto(this.symbol)) {
            Object.assign(override, {"mainSeriesProperties.style": chartingLibrary.SeriesStyle.Line});
            Object.assign(override, {"mainSeriesProperties.lineStyle.color": "#CC0000"});
        }
        return override
    }

    public initOnReady() {
      const script = this.renderer.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js';
      script.async = true;
      script.text = JSON.stringify({
        "autosize": true,
        "symbol": this.symbol,
        "interval": '1D' as chartingLibrary.ResolutionString,
        "timezone": 'America/Sao_Paulo',
        "theme": 'light',
        "style": '1',
        "locale": 'br',
        "withdateranges": true,
        "hide_side_toolbar": false,
        "allow_symbol_change": false,
        "hide_volume": true,
        "hide_legend": false,
        "details": false,
        "fullscreen": true,
        "container": 'tradingview-widget-container',
        "support_host": 'https://www.toroinvestimentos.com.br/',
        "customer": "toroinvestimentoscom",
        "settings_overrides": this.chartOverrides(),
      });
      const container = this.renderer.selectRootElement('.tradingview-widget-container');
      this.renderer.appendChild(container, script);
    }
}
